// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: r9DFvEHe5Pso

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicWebPreview.module.css"; // plasmic-import: r9DFvEHe5Pso/css

createPlasmicElementProxy;

export type PlasmicWebPreview__VariantMembers = {};
export type PlasmicWebPreview__VariantsArgs = {};
type VariantPropType = keyof PlasmicWebPreview__VariantsArgs;
export const PlasmicWebPreview__VariantProps = new Array<VariantPropType>();

export type PlasmicWebPreview__ArgsType = {
  image?: string;
  url?: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
};
type ArgPropType = keyof PlasmicWebPreview__ArgsType;
export const PlasmicWebPreview__ArgProps = new Array<ArgPropType>(
  "image",
  "url",
  "title",
  "description"
);

export type PlasmicWebPreview__OverridesType = {
  root?: p.Flex<"a">;
  titleImageContainer?: p.Flex<"div">;
  img?: p.Flex<typeof p.PlasmicImg>;
  textContainer?: p.Flex<"div">;
  url?: p.Flex<"div">;
  titleContainer?: p.Flex<"div">;
  descriptionContainer?: p.Flex<"div">;
};

export interface DefaultWebPreviewProps {
  image?: string;
  url?: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicWebPreview__RenderFunc(props: {
  variants: PlasmicWebPreview__VariantsArgs;
  args: PlasmicWebPreview__ArgsType;
  overrides: PlasmicWebPreview__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          url: "https://hubhub.app"
        },
        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <a
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.a,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root
      )}
      href={(() => {
        try {
          return $props.url;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      target={"_blank"}
    >
      <div
        data-plasmic-name={"titleImageContainer"}
        data-plasmic-override={overrides.titleImageContainer}
        className={classNames(projectcss.all, sty.titleImageContainer)}
      >
        <p.PlasmicImg
          data-plasmic-name={"img"}
          data-plasmic-override={overrides.img}
          alt={""}
          className={classNames(sty.img)}
          displayHeight={"100%"}
          displayMaxHeight={"none"}
          displayMaxWidth={"100%"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"100%"}
          loader={"plasmic"}
          loading={"lazy"}
          src={$props.image}
        />
      </div>
      <p.Stack
        as={"div"}
        data-plasmic-name={"textContainer"}
        data-plasmic-override={overrides.textContainer}
        hasGap={true}
        className={classNames(projectcss.all, sty.textContainer)}
      >
        <div
          data-plasmic-name={"url"}
          data-plasmic-override={overrides.url}
          className={classNames(projectcss.all, projectcss.__wab_text, sty.url)}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.url;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "www.domain.com";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </div>
        <div
          data-plasmic-name={"titleContainer"}
          data-plasmic-override={overrides.titleContainer}
          className={classNames(projectcss.all, sty.titleContainer)}
        >
          {p.renderPlasmicSlot({
            defaultContents: "Fallback Title",
            value: args.title,
            className: classNames(sty.slotTargetTitle)
          })}
        </div>
        <div
          data-plasmic-name={"descriptionContainer"}
          data-plasmic-override={overrides.descriptionContainer}
          className={classNames(projectcss.all, sty.descriptionContainer)}
        >
          {p.renderPlasmicSlot({
            defaultContents: "Fallback description",
            value: args.description,
            className: classNames(sty.slotTargetDescription)
          })}
        </div>
      </p.Stack>
    </a>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "titleImageContainer",
    "img",
    "textContainer",
    "url",
    "titleContainer",
    "descriptionContainer"
  ],
  titleImageContainer: ["titleImageContainer", "img"],
  img: ["img"],
  textContainer: [
    "textContainer",
    "url",
    "titleContainer",
    "descriptionContainer"
  ],
  url: ["url"],
  titleContainer: ["titleContainer"],
  descriptionContainer: ["descriptionContainer"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "a";
  titleImageContainer: "div";
  img: typeof p.PlasmicImg;
  textContainer: "div";
  url: "div";
  titleContainer: "div";
  descriptionContainer: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicWebPreview__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicWebPreview__VariantsArgs;
    args?: PlasmicWebPreview__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicWebPreview__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicWebPreview__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebPreview__ArgProps,
          internalVariantPropNames: PlasmicWebPreview__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebPreview__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicWebPreview";
  } else {
    func.displayName = `PlasmicWebPreview.${nodeName}`;
  }
  return func;
}

export const PlasmicWebPreview = Object.assign(
  // Top-level PlasmicWebPreview renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    titleImageContainer: makeNodeComponent("titleImageContainer"),
    img: makeNodeComponent("img"),
    textContainer: makeNodeComponent("textContainer"),
    url: makeNodeComponent("url"),
    titleContainer: makeNodeComponent("titleContainer"),
    descriptionContainer: makeNodeComponent("descriptionContainer"),

    // Metadata about props expected for PlasmicWebPreview
    internalVariantProps: PlasmicWebPreview__VariantProps,
    internalArgProps: PlasmicWebPreview__ArgProps
  }
);

export default PlasmicWebPreview;
/* prettier-ignore-end */
